import ReconcileAllocatedRevenueStore from "./ReconcileAllocatedRevenue/ReconcileAllocatedRevenueStore";
import CheckSuggestFeesStore from "./CheckSuggestFees/CheckSuggestFeesStore";

export const AccountantStore = {
  reconcileAllocatedRevenueStore: new ReconcileAllocatedRevenueStore(),
  checkSuggestFeesStore: new CheckSuggestFeesStore(),
};
